var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Box, Link, Typography, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { LOCAL_STORAGE_KEYS } from "../../../../constants";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { FormItemTypes } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import InfiniteScroll from "../../../../builderPackage/components/infiniteScroll/infiniteScroll";
import { getLocalStorageItem } from "../../../../utils/storageHelper";
import { dateFormate } from "../../../../utils/utils";
// import { ContractSaleOrderPagingAPI } from "../services/apiCall";
// import { ContractSaleOrderKeys } from "../services/entity";
import { ExpandLess, ExpandMore, MoreVert } from "@mui/icons-material";
// import { ContractSaleOrderCancelPopup } from "./ContractSaleOrderCancelPopup";
import { useEffect, useRef, useState } from "react";
export var UtilityMobileView = function (props) {
    var _getLocalStorageItem, _getLocalStorageItem2;
    var value = props.value;
    var userOrganizationID = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var parentOrganizationId = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.Branches[0]) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.ParentOrganizationId;
    var upXS = useMediaQuery(function (theme) { return theme.breakpoints.up("xs"); });
    var downSM = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var storedMenuFeatures = getLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_FEATURE);
    var IS_MOBILE = upXS && downSM;
    var crud = useAppSelector(function (state) { return state.crud; });
    var appDispatch = useAppDispatch();
    var dispatch = useAppDispatch();
    var navigate = useNavigate();
    // const hasMore = !crud[ContractSaleOrderKeys.Paging] || (crud[ContractSaleOrderKeys.Paging]?.data?.length < crud[ContractSaleOrderKeys.Paging]?.TotalCount)
    var data = [{
            OrderNumber: "SO-2025-00123",
            OrderDate: "2025-04-08T10:00:00Z",
            expanded: true,
            GroupName: "#PC-782773 | Brake liners",
            PartName: "#PC-782773 | Brake liners",
            DefectDescription: "Wear and tear observed after 5k km",
            Owner: "Rahul Desai",
            Category1: "Mechanical",
            Category2: "Brake System",
            AssignedTo: "Sunil Patil",
            AssignedBy: "Priya Nair",
            Intensity: "High",
            Ageing: "2 weeks",
            Source: "Customer feedback",
            PSGRemarks: "Under review"
        }, {
            OrderNumber: "SO-2025-00123",
            OrderDate: "2025-04-08T10:00:00Z",
            expanded: true,
            GroupName: "#PC-782773 | Brake liners",
            PartName: "#PC-782773 | Brake liners",
            DefectDescription: "Wear and tear observed after 5k km",
            Owner: "Rahul Desai",
            Category1: "Mechanical",
            Category2: "Brake System",
            AssignedTo: "Sunil Patil",
            AssignedBy: "Priya Nair",
            Intensity: "High",
            Ageing: "2 weeks",
            Source: "Customer feedback",
            PSGRemarks: "Under review for warranty claim and i want to truncate if it goes above 3 lines to truncate if it goes above 3 lines"
        }, {
            OrderNumber: "SO-2025-00123",
            OrderDate: "2025-04-08T10:00:00Z",
            expanded: true,
            GroupName: "#PC-782773 | Brake liners",
            PartName: "#PC-782773 | Brake liners",
            DefectDescription: "Wear and tear observed after 5k km",
            Owner: "Rahul Desai",
            Category1: "Mechanical",
            Category2: "Brake System",
            AssignedTo: "Sunil Patil",
            AssignedBy: "Priya Nair",
            Intensity: "High",
            Ageing: "2 weeks",
            Source: "Customer feedback",
            PSGRemarks: "Under review for warranty claim and i want to truncate if it goes above 3 lines to truncate if it goes above 3 lines"
        }];
    var ExpandableText = function (_ref) {
        var _a = _ref.text, text = _a === void 0 ? '' : _a, _b = _ref.lineClamp, lineClamp = _b === void 0 ? 2 : _b;
        var _c = useState(false), expanded = _c[0], setExpanded = _c[1];
        var _d = useState(false), isOverflowing = _d[0], setIsOverflowing = _d[1];
        var textRef = useRef(null);
        useEffect(function () {
            var el = textRef.current;
            if (el) {
                var lineHeight = parseFloat(getComputedStyle(el).lineHeight || '20'); // fallback to 20px
                var maxHeight = 1.5 * lineHeight;
                setIsOverflowing(el.scrollHeight > maxHeight);
            }
        }, [text, lineClamp]);
        var toggleExpanded = function () { return setExpanded(!expanded); };
        var collapsedStyle = {
            display: '-webkit-box',
            WebkitLineClamp: lineClamp,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'normal'
        };
        return /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(Typography, {
            ref: textRef,
            sx: _objectSpread(_objectSpread({}, expanded ? {} : collapsedStyle), {}, {
                fontSize: 'sm',
                fontWeight: 'medium',
                whiteSpace: 'pre-wrap',
                textAlign: 'left'
            })
        }, !isOverflowing ? text : !expanded ? text + '...' : text), isOverflowing && /*#__PURE__*/ React.createElement(Link, {
            component: "button",
            onClick: toggleExpanded,
            underline: "none",
            sx: {
                fontSize: 'sm',
                fontWeight: 'medium',
                mt: 0.5,
                display: 'inline-block'
            }
        }, expanded ? 'less' : 'more'));
    };
    var formData = [{
            type: FormItemTypes.CardComponent,
            name: '',
            columnSize: 12,
            onClick: function () { },
            contentProps: {
                spacing: 0.5
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    justifyContent: "space-between",
                    display: "flex",
                    alignItems: 'start',
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 8,
                            justifyContent: 'center',
                            alignItems: 'flex-start',
                            flexDirection: 'column',
                            spacing: 0,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: "OrderNumber",
                                    columnSize: true,
                                    labelTypographyProps: {
                                        fontSize: 'base',
                                        fontWeight: 'medium'
                                    },
                                    fontSize: 'base',
                                    fontWeight: 'medium'
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: "OrderDate",
                                    valueGetter: function (val, row) { return val !== null && val !== void 0 && val.OrderDate ? "".concat(dateFormate(val === null || val === void 0 ? void 0 : val.OrderDate)) : '-'; },
                                    // label: cardData.docNo,
                                    columnSize: true,
                                    labelTypographyProps: {
                                        fontSize: 'base',
                                        fontWeight: 'medium',
                                        color: 'secondary.900'
                                    },
                                    fontSize: 'sm',
                                    fontWeight: 'normal',
                                    color: 'secondary.500'
                                }]
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 4,
                            justifyContent: 'flex-end',
                            alignItems: 'baseline',
                            spacing: 0,
                            elements: [{
                                    type: FormItemTypes.IconButton,
                                    name: '',
                                    children: /*#__PURE__*/ React.createElement(MoreVert, null),
                                    // variant: 'outlined',
                                    size: 'small',
                                    columnSize: 0,
                                    color: 'info',
                                    sx: {
                                        paddingTop: 0
                                    }
                                }]
                        }]
                }, {
                    type: FormItemTypes.Accordian,
                    name: 'expanded',
                    value: false,
                    containerProps: {
                        marginTop: 1
                    },
                    summaryProps: {
                        sx: {
                            display: 'none',
                            border: 'none'
                        }
                    },
                    summary: [],
                    detailPanelProps: {
                        spacing: 4,
                        rowSpacing: 0
                    },
                    sx: {
                        bgcolor: 'background.secondary',
                        border: 'none'
                    },
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.CardComponent,
                            name: '',
                            columnSize: 12,
                            onClick: function () { },
                            contentProps: {
                                spacing: 1,
                                border: 'none'
                            },
                            sx: {
                                border: 'none',
                                backgroundColor: 'background.secondary'
                            },
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    columnSize: 12,
                                    spacing: 1,
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: 'GroupName',
                                            label: 'Group name & code:',
                                            fontSize: 'sm',
                                            fontWeight: 'medium',
                                            columnSize: 12,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                fontWeight: 'medium',
                                                fontSize: 'sm',
                                                textOverflow: 'initial'
                                            },
                                            textAlign: 'end'
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'PartName',
                                            label: 'Part name & code:',
                                            fontSize: 'sm',
                                            fontWeight: 'medium',
                                            columnSize: 12,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                fontWeight: 'medium',
                                                fontSize: 'sm',
                                                textOverflow: 'initial'
                                            },
                                            textAlign: 'end'
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'DefectDescription',
                                            label: 'Defect description & code:',
                                            fontSize: 'sm',
                                            fontWeight: 'medium',
                                            columnSize: 12,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                fontWeight: 'medium',
                                                fontSize: 'sm',
                                                textOverflow: 'initial'
                                            },
                                            textAlign: 'end'
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'Owner',
                                            label: 'Owner :',
                                            fontSize: 'sm',
                                            fontWeight: 'medium',
                                            columnSize: 12,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                fontWeight: 'medium',
                                                fontSize: 'sm',
                                                textOverflow: 'initial'
                                            }
                                            // textAlign: 'end'
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'Category1',
                                            label: 'Category :',
                                            fontSize: 'sm',
                                            fontWeight: 'medium',
                                            columnSize: 12,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                fontWeight: 'medium',
                                                fontSize: 'sm',
                                                textOverflow: 'initial'
                                            },
                                            textAlign: 'end'
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'Category2',
                                            label: 'Category :',
                                            fontSize: 'sm',
                                            fontWeight: 'medium',
                                            columnSize: 12,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                fontWeight: 'medium',
                                                fontSize: 'sm',
                                                textOverflow: 'initial'
                                            },
                                            textAlign: 'end'
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'AssignedTo',
                                            label: 'Assigned to :',
                                            fontSize: 'sm',
                                            fontWeight: 'medium',
                                            columnSize: 12,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                fontWeight: 'medium',
                                                fontSize: 'sm',
                                                textOverflow: 'initial'
                                            },
                                            textAlign: 'end'
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'AssignedBy',
                                            label: 'Assigned by :',
                                            fontSize: 'sm',
                                            fontWeight: 'medium',
                                            columnSize: 12,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                fontWeight: 'medium',
                                                fontSize: 'sm',
                                                textOverflow: 'initial'
                                            },
                                            textAlign: 'end'
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'Intensity',
                                            label: 'Intensity :',
                                            fontSize: 'sm',
                                            fontWeight: 'medium',
                                            columnSize: 12,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                fontWeight: 'medium',
                                                fontSize: 'sm',
                                                textOverflow: 'initial'
                                            },
                                            textAlign: 'end'
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'Ageing',
                                            label: 'Ageing :',
                                            fontSize: 'sm',
                                            fontWeight: 'medium',
                                            columnSize: 12,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                fontWeight: 'medium',
                                                fontSize: 'sm',
                                                textOverflow: 'initial'
                                            },
                                            textAlign: 'end'
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'Source',
                                            label: 'Source :',
                                            fontSize: 'sm',
                                            fontWeight: 'medium',
                                            columnSize: 12,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                fontWeight: 'medium',
                                                fontSize: 'sm',
                                                textOverflow: 'initial'
                                            },
                                            textAlign: 'end'
                                        },
                                        // {
                                        //     type: FormItemTypes.Typography,
                                        //     name: 'PSGRemarks',
                                        //     label: 'PSG remarks :',
                                        //     fontSize: 'sm',
                                        //     fontWeight: 'medium',
                                        //     columnSize: 12,
                                        //     containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
                                        //     labelTypographyProps: { mb: 0, fontWeight: 'medium', fontSize: 'sm', textOverflow: 'initial' },
                                        //     textAlign: 'end',
                                        //      valueGetter(formValues, field) {
                                        //         const currValue = formValues?.[this.name];
                                        //         console.log('field: ',currValue)
                                        //         if (currValue) return currValue
                                        //         else return '-'
                                        //     },
                                        // },
                                        {
                                            type: FormItemTypes.Typography,
                                            name: 'PSGRemarks',
                                            label: 'PSG remarks:',
                                            fontSize: 'sm',
                                            fontWeight: 'medium',
                                            columnSize: 12,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                fontWeight: 'medium',
                                                fontSize: 'sm',
                                                textOverflow: 'initial'
                                            },
                                            textAlign: 'end',
                                            valueGetter: function (formValues, field) {
                                                var currValue = formValues === null || formValues === void 0 ? void 0 : formValues[this.name];
                                                return /*#__PURE__*/ React.createElement(ExpandableText, {
                                                    text: currValue || '-',
                                                    lineClamp: 2
                                                });
                                            }
                                        }]
                                }]
                        }]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    justifyContent: 'end',
                    elements: [{
                            type: FormItemTypes.Button,
                            name: 'expand-button',
                            columnSize: 0,
                            color: 'secondary',
                            size: 'small',
                            sx: {
                                p: 0,
                                fontSize: 'sm'
                            },
                            setFormState: function (formValues) {
                                return {
                                    expanded: !(formValues !== null && formValues !== void 0 && formValues.expanded)
                                };
                            },
                            setFieldProps: function (formValues) {
                                return {
                                    type: this.type,
                                    children: formValues !== null && formValues !== void 0 && formValues.expanded ? ['Close', /*#__PURE__*/ React.createElement(ExpandLess, null)] : ['View more', /*#__PURE__*/ React.createElement(ExpandMore, null)]
                                };
                            }
                        }]
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(InfiniteScroll, {
        apiKey: "asd",
        apiCall: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, {
                        data: data
                    }];
            });
        }); },
        elements: formData,
        hasMore: true,
        gridContainerProps: {
            spacing: 2,
            p: 2
        }
    }));
};
